import { Notify } from 'quasar'
import FormsService from 'src/services/forms'

export default {
  fetchCritical () {
    const promise = FormsService.fetchCritical()

    promise.then(response => {
      this.critical = response.data.forms
      this.criticalItems = response.data.items
    }).catch(err => { console.error(err) })

    return promise
  },
  fetchAll () {
    this.status = 'loading'
    const promise = FormsService.fetchAll()

    promise.then(data => {
      this.forms = data.data
      if (data.meta && data.meta.pagination) this.pagination = data.meta.pagination
      this.status = 'success'
    }).catch(err => { console.error(err) })

    return promise
  },
  fetchPaginated (payload = {}) {
    this.status = 'loading'
    const page = payload.page || 1
    if (page === 1 && payload.clearFirst !== false) this.forms = []

    const promise = FormsService.fetchPaginated(payload)

    promise
      .then(data => {
        if (Array.isArray(data)) {
          this.forms = []
        } else if (page === 1 && payload.clearFirst !== false) {
          this.forms = data.data
        } else {
          this.forms = this.forms.concat(data.data)
        }
        if (data.data.length > 0) {
          this.pagination = {
            count: data.to,
            current_page: data.current_page,
            links: [],
            per_page: data.per_page,
            total: data.total,
            total_pages: data.last_page
          }
        }
        this.status = 'success'
      })
      .catch(err => {
        console.error(err)
      })

    return promise
  },
  fetchBlocks () {
    const promise = FormsService.fetchBlocks()

    promise.then(data => this.blocks = data.data || [])
      .catch(err => { console.error(err) })

    return promise
  },
  createBlock (payload) {
    const promise = FormsService.createBlock(payload)

    promise.then(data => this.blocks.push(data.data.block))
      .catch(err => { console.error(err) })

    return promise
  },
  removeBlock ({ blockId }) {
    const promise = FormsService.removeBlock(blockId)

    promise.then(() => this.blocks = this.blocks.filter(_block => _block.id !== blockId))
      .catch(err => { console.error(err) })

    return promise
  },
  addFormToBlock ({ blockId, formId }) {
    const promise = FormsService.addFormToBlock(blockId, formId)

    promise.then(() => {
      const form = this.forms.find(_form => _form.id === formId)
      const blockIndex = this.blocks.findIndex(_block => _block.id === blockId)
      if (blockIndex === -1) return

      this.blocks[blockIndex].forms.push(form)
    }).catch(err => { console.error(err) })

    return promise
  },
  removeFormFromBlock ({ blockId, formId }) {
    const promise = FormsService.removeFormFromBlock(blockId, formId)

    promise.then(() => {
      const blockIndex = this.blocks.findIndex(_block => _block.id === blockId)
      if (blockIndex === -1) return
      this.blocks[blockIndex].forms = this.blocks[blockIndex].forms.filter(_form => _form.id !== formId)
    }).catch(err => { console.error(err) })

    return promise
  },
  remove (id) {
    this.forms = this.forms.filter(form => form.id !== id)
  },
  addPonderationToBlock (blockId) {
    const block = this.blocks.find(_block => _block.id === blockId)
    const ponderation = {}
    block.forms.forEach(form => {
      ponderation[form.id] = parseFloat((100 / block.forms.length).toFixed(2))
    })

    block.ponderation = ponderation

    this.updateBlockPonderation(block)
  },
  updateBlockPonderation (block) {
    const promise = FormsService.updateBlockPonderation(block)

    const blockIndex = this.blocks.findIndex(_block => _block.id === block.id)
    this.blocks[blockIndex].ponderation = block.ponderation

    return promise
  },
  downloadTemplate (payload) {
    const promise = FormsService.downloadTemplate(payload)

    return promise
  },
  uploadTemplate (payload) {
    const promise = FormsService.uploadTemplate(payload)

    promise.then(() => {
      this.message = 'success'
    }).catch(err => {
      this.message = 'error'
      console.error(err)
    })

    return promise
  },
  fetchGroupsByForm (formId) {
    const promise = FormsService.fetchGroupsByForm(formId)

    promise.then(data => {
      this.groups = data
    }).catch(err => { console.error(err) })

    return promise
  },
  fetchItemsByForm (groupId) {
    const promise = FormsService.fetchItemsByForm(groupId)

    promise.then(data => {
      this.items = data
    }).catch(err => { console.error(err) })

    return promise
  },
  addLogicRules (payload) {
    const promise = FormsService.addLogicRules(payload)

    promise.catch(err => {
      Notify.create({
        color: 'binnacle-red',
        message: err?.data?.error || 'No se pudo guardar la condición.',
        icon: 'error',
        timeout: 5000
      })
    })

    return promise
  },
  changeGroupId (payload) {
    this.groupId = payload
  },
  updateList (form) {
    const item = this.forms.find(item => item.id === form.id)

    if (item) Object.assign(item, form)
    else this.forms.unshift(form)
  },
  // Testing actions
  createTestOccurrence (formId) {
    const promise = FormsService.createTestOccurrence(formId)

    promise
      .then(data => {
        this.currentTestOccurrence = data
      })
      .catch(err => {
        console.error('Error createTestOccurrence:', err)
      })

    return promise
  },
  updateTestStatus ({ formId, status }) {
    const promise = FormsService.updateTestStatus(formId, status)
      .catch(err => { console.error(err) })
    return promise
  },
  sendToTest (formId) {
    const promise = FormsService.sendToTest(formId)
      .catch(err => { console.error(err) })
    return promise
  },
  completeTest ({ formId, payload }) {
    const promise = FormsService.completeTest(formId, payload)

    promise.then(() => {
      this.currentTestOccurrence = null
      this.testAnswers = {}
      this.testAddons = {}
    }).catch((error) => {
      console.error('Error completeTest:', error)
    })

    return promise
  },
  // Test answer management
  saveTestAnswer (payload) {
    this.testAnswers = { ...this.testAnswers, [payload.item_id]: payload.value }

    if (this.currentTestOccurrence) {
      const fullPayload = {
        occurrence_id: this.currentTestOccurrence.id,
        ...payload
      }

      const promise = FormsService.saveTestAnswer(fullPayload)

      promise.catch(err => {
        console.error('Error saving test answer:', err)
      })

      return promise
    }

    return Promise.resolve()
  },
  updateItemOptions (payload, formId) {
    return FormsService.updateItemOptions(payload, formId)
  },
  saveTestAnswersBatch (answers) {
    answers.forEach(answer => {
      this.testAnswers = { ...this.testAnswers, [answer.item_id]: answer.value }
    })

    if (this.currentTestOccurrence) {
      const payload = {
        occurrence_id: this.currentTestOccurrence.id,
        answers: answers
      }

      const promise = FormsService.saveTestAnswersBatch(payload)

      promise.catch(err => {
        console.error('Error saving batch test answers:', err)
      })

      return promise
    }

    return Promise.resolve()
  },
  loadTestAnswers () {
    if (this.currentTestOccurrence) {
      const promise = FormsService.getTestAnswers(this.currentTestOccurrence.id)

      promise.then(answers => {
        const answersObj = {}
        answers.forEach(answer => {
          answersObj[answer.item_id] = answer.value
        })
        this.testAnswers = answersObj
      }).catch(err => { console.error(err) })

      return promise
    }

    return Promise.resolve()
  },
  getTestHistory (formId) {
    const promise = FormsService.getTestHistory(formId)
      .catch(err => { console.error(err) })
    return promise
  },
  fetchPendingTests () {
    this.status = 'loading'
    const promise = FormsService.fetchPendingTests()

    promise.then(response => {
      const statusMap = {
        'pending': 'untested',
        'pending_test': 'untested',
        'sent': 'untested',
        'in_progress': 'testing',
        'started': 'testing',
        'testing': 'testing',
        'completed': 'tested',
        'finished': 'tested',
        'tested': 'tested',
        'approved': 'approved',
        'rejected': 'rejected',
        'published': 'published',
        'commented': 'commented'
      }

      const latestTestRecords = {}
      response.data.forEach(testRecord => {
        const formId = testRecord.form_id
        if (!latestTestRecords[formId] ||
            new Date(testRecord.created_at) > new Date(latestTestRecords[formId].created_at)) {
          latestTestRecords[formId] = testRecord
        }
      })

      const formsWithTestInfo = Object.values(latestTestRecords).map(testRecord => {
        let mappedStatus
        const formStatus = testRecord.form?.status ? testRecord.form.status.toLowerCase().trim() : null
        const testRecordStatus = testRecord.status ? testRecord.status.toLowerCase().trim() : null

        if (formStatus && ['approved', 'rejected', 'published'].includes(formStatus)) {
          mappedStatus = statusMap[formStatus] || formStatus
        } else if (testRecordStatus && ['approved', 'rejected', 'published'].includes(testRecordStatus)) {
          mappedStatus = statusMap[testRecordStatus] || testRecordStatus
        } else if (testRecord.completed_at) {
          mappedStatus = 'tested'
        } else if (testRecord.started_at) {
          mappedStatus = 'testing'
        } else {
          mappedStatus = statusMap[testRecordStatus] || 'untested'
        }

        return {
          ...testRecord.form,
          test_record_id: testRecord.id,
          test_status: mappedStatus,
          sent_by_user: testRecord.sent_by_user,
          assigned_tester: testRecord.assigned_tester,
          sent_at: testRecord.sent_at,
          started_at: testRecord.started_at,
          completed_at: testRecord.completed_at,
          test_feedback: testRecord.feedback,
          approval_status: testRecord.approval_status
        }
      })

      const visibleTests = formsWithTestInfo.filter(form => {
        return form.approval_status !== 'published'
      })

      this.pendingTests = visibleTests
      this.status = 'success'
    }).catch(err => {
      this.status = 'error'
      throw err
    })

    return promise
  },
  setPendingTestLocalStatus (formId, patch) {
    const form = this.pendingTests.find(pendingTest => pendingTest.id === formId)
    if (form) Object.assign(form, patch)
  },
  checkExistingTest (formId) {
    const promise = FormsService.checkExistingTest(formId)

    promise
      .then(data => {
        if (data?.id) {
          this.currentTestOccurrence = data
          if (data.occurrence_answers?.length > 0) {
            const answersObj = {}
            data.occurrence_answers.forEach(answer => {
              answersObj[answer.item_id] = answer.value
            })
            this.testAnswers = answersObj
          }
        }
      })
      .catch(err => {
        console.error('Error checkExistingTest:', err)
      })

    return promise
  },
  approveForm ({ formId, testRecordId }) {
    const promise = FormsService.approveForm(formId, testRecordId)
      .catch(err => { console.error(err) })
    return promise
  },
  rejectForm ({ formId, testRecordId, reason }) {
    const promise = FormsService.rejectForm(formId, testRecordId, reason)
      .catch(err => { console.error(err) })
    return promise
  },
  publishForm (formId) {
    const promise = FormsService.publishForm(formId)

    promise
      .then(data => {
        if (data?.id) {
          const formIndex = this.forms.findIndex(form => form.id === Number.parseInt(formId, 10))
          if (formIndex !== -1) {
            const updatedForm = { ...this.forms[formIndex], ...data }
            updatedForm.status = 'published'
            if (!updatedForm.assignment) updatedForm.assignment = {}
            updatedForm.assignment.published = true
            if (!updatedForm.test_fields) updatedForm.test_fields = {}
            updatedForm.test_fields.approval_status = 'published'
            this.updateList(updatedForm)
          }
        }
      })
      .catch(err => {
        console.error('Error publishForm:', err)
        throw err
      })

    return promise
  },
  returnToDraft (formId) {
    const promise = FormsService.returnToDraft(formId)
      .catch(err => { console.error(err) })
    return promise
  },
  addFormTestComment ({ formId, testRecordId, comment }) {
    const promise = FormsService.addTestComment(formId, testRecordId, comment)
    return promise
  },
  downloadTestPDF (payload) {
    const promise = FormsService.downloadTestPDF(payload)

    promise
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const filename = `[PRUEBA] ${payload.form_name} - ${payload.location_name}.pdf`

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()

        link.remove()
        window.URL.revokeObjectURL(url)
      })
      .catch(err => {
        console.error('Error downloadTestPDF:', err)
        throw err
      })

    return promise
  },
  sendTestOccurrenceByEmail (payload) {
    const promise = FormsService.sendTestOccurrenceByEmail(payload)
      .catch(err => { console.error(err) })
    return promise
  },
  addTestComment ({ testOccurrenceId, itemId }) {
    const payload = {
      item_id: itemId,
      type: 'comment',
      answer: ''
    }

    const promise = FormsService.createTestAddon(testOccurrenceId, payload)

    promise
      .then(data => {
        const addonData = data.data || data
        if (!this.testAddons[itemId]) this.testAddons[itemId] = []
        this.testAddons = { ...this.testAddons, [itemId]: [...(this.testAddons[itemId] || []), addonData] }
      })
      .catch(err => {
        console.error('Error addTestComment:', err)
        throw err
      })

    return promise
  },
  addTestImage ({ testOccurrenceId, itemId, image }) {
    const payload = {
      item_id: itemId,
      type: 'picture',
      answer: image
    }

    const promise = FormsService.createTestAddon(testOccurrenceId, payload)

    promise
      .then(data => {
        const addonData = data.data || data
        if (!this.testAddons[itemId]) this.testAddons[itemId] = []
        this.testAddons = { ...this.testAddons, [itemId]: [...(this.testAddons[itemId] || []), addonData] }
      })
      .catch(err => {
        console.error('Error addTestImage:', err)
        throw err
      })

    return promise
  },
  updateTestAddon ({ testOccurrenceId, addonId, itemId, answer }) {
    const payload = { answer }

    const promise = FormsService.updateTestAddon(testOccurrenceId, addonId, payload)

    promise
      .then(() => {
        if (this.testAddons[itemId]) {
          const addonIndex = this.testAddons[itemId].findIndex(a => a.id === addonId)
          if (addonIndex !== -1) {
            this.testAddons[itemId][addonIndex].answer = answer
          }
        }
      })
      .catch(err => {
        console.error('Error updateTestAddon:', err)
        throw err
      })

    return promise
  },
  fetchForApproval (payload = {}) {
    this.status = 'loading'
    const page = payload.page || 1

    if (page === 1 && payload.clearFirst !== false) {
      this.formsForApproval = []
    }

    const promise = FormsService.fetchForApproval(payload)
    promise
      .then(data => {
        if (page === 1 && payload.clearFirst !== false) {
          this.formsForApproval = data.data
        } else {
          this.formsForApproval = this.formsForApproval.concat(data.data)
        }

        if (data.data.length > 0) {
          this.approvalPagination = {
            count: data.pagination.current_page * data.pagination.per_page,
            current_page: data.pagination.current_page,
            links: [],
            per_page: data.pagination.per_page,
            total: data.pagination.total,
            total_pages: data.pagination.last_page
          }
        }
        this.status = 'success'
      })
      .catch(error => {
        console.error('Error fetchForApproval:', error)
        this.status = 'error'
      })

    return promise
  },
  addApprovalComment ({ formId, testRecordId, comment }) {
    const promise = FormsService.addApprovalComment(formId, testRecordId, comment)
      .catch(err => { console.error(err) })
    return promise
  },
  clearTestSession () {
    this.currentTestOccurrence = null
    this.testAnswers = {}
    this.testAddons = {}
  },
  setCurrentTestOccurrence (occurrence) {
    this.currentTestOccurrence = occurrence
  },
  setTestAnswer ({ itemId, value }) {
    this.testAnswers = { ...this.testAnswers, [itemId]: value }
  },
  setTestAnswers (answers) {
    this.testAnswers = answers
  }
}
